<template>
    <div class="register_main_wrap">
        <div class="reg_top">
            {{$t('loginText1')}}
            <br>{{$t('loginText2')}}
            <div><img src="@/assets/image/main/logo2.png" alt=""></div>
        </div>
        <register-component></register-component>
    </div>
</template>

<script>

export default {
    name: "Login",
    mixins: [],
    components: {
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
    },
    watch: {},
}
</script>

<style scoped>

</style>